module.exports = __webpack_public_path__ + "static/media/r22.8daafad5.jpg";